import React, { useState } from "react";
import { useFetchContext } from "../../../../common/FetchContext";
import { toast } from "react-toastify";
import { useSaveRetestEdgePinchResults } from "../../../projectManagementMutations";
import { Box, Button, Grid, Paper, Typography } from "@material-ui/core";
import { useQueryClient } from "react-query";

export const EdgeRetestFinalSubmitStage = ({
  tableData,
  onBack,
  asset,
  showdata,
  onSuccess,
}: any) => {
  const { authAxios } = useFetchContext();
  const queryClient = useQueryClient();

  const { mutateAsync: mutateretestEdgePinch } =
    useSaveRetestEdgePinchResults();

  const [saving, setSaving] = useState(false);

  const modules = tableData?.map((item: any) => item.serial_number).join(", ");

  const handleSubmit = async () => {
    try {
      setSaving(true);

      const payload = {
        project_number:showdata.project_number,
        customer_name:showdata.customer_name,
        bom: showdata.bom,
        asset_id:showdata.asset_id,
        data: tableData,
      };
        await mutateretestEdgePinch({
          authAxios,
          ...payload,
        });

      console.log("payload:", payload);
      toast.success("Edge Pinch Measurements submitted successfully!");
      // API CALL
      onSuccess?.();
      queryClient.invalidateQueries("travelerResults");
    } catch (error) {
      toast.error("Error submitting measurements. Please try again.");
    } finally {
      setSaving(false);
    }
  };
  return (
    <>
      <Typography variant="h6">Submit Measurements</Typography>
      <Box mt={2}>
        <Paper elevation={2} style={{ padding: 16 }}>
          <Typography variant="h6" gutterBottom>
            Project Details
          </Typography>

          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Typography>
                <strong>Project Number:</strong>
              </Typography>
              <Typography color="textSecondary">
                {showdata.project_number}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography>
                <strong>Customer Name:</strong>
              </Typography>
              <Typography color="textSecondary">
                {showdata.customer_name}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography>
                <strong>BOM:</strong>
              </Typography>
              <Typography color="textSecondary">{showdata.bom}</Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography>
                <strong>Modules:</strong>
              </Typography>
              <Typography color="textSecondary">{modules}</Typography>
            </Grid>
          </Grid>
        </Paper>
      </Box>

      <Box mt={3} display="flex" justifyContent="space-between">
        <Button variant="outlined" onClick={onBack}>
          Back
        </Button>

        <Button
          variant="contained"
          color="secondary"
          onClick={handleSubmit}
          disabled={saving}
        >
          {saving ? "Submitting..." : "Submit Measurements"}
        </Button>
      </Box>
    </>
  );
};
